import i18next from 'i18next';
import {emptyStateHtml} from '../../common/js/empty-state';
import {escapeHtml} from '../../common/js/html';

export const COUNT_EVENT = 'inapp-notifications:count';
// A read in the bell, for the notifications page: {id} for one item, {upToId} for "Mark all as read".
export const READ_EVENT = 'inapp-notifications:read';

const RELATIVE_UNITS = [['day', 86400], ['hour', 3600], ['minute', 60]];
const WEEK_SECONDS = 7 * 86400;

// Icon paths from Lucide (ISC license; lucide-react is already a project dependency).
const ICON_PATHS = {
    system: '<path d="M10.268 21a2 2 0 0 0 3.464 0"/><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"/>',
    olx_accounts: '<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
    files: '<rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>',
    billing: '<rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/>',
    broadcast: '<path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/>',
};
// Icons the header already uses, so a notification shows the same symbol as the place it is about: the balance
// icons under the header (templates/includes/icons/resource_tokens.svg, resource_connections.svg) and the header's
// Bots link (static/img/svg/bots_nav.svg). Keep them in step with those files.
const SITE_ICONS = {
    bots: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true" focusable="false"><g fill="currentColor"><path d="M181 301c-8.284 0-15 6.716-15 15v30c0 8.284 6.716 15 15 15s15-6.716 15-15v-30c0-8.284-6.716-15-15-15zM331 361c8.284 0 15-6.716 15-15v-30c0-8.284-6.716-15-15-15s-15 6.716-15 15v30c0 8.284 6.716 15 15 15zM272 106h164c8.284 0 15-6.716 15-15s-6.716-15-15-15H272c-8.284 0-15 6.716-15 15s6.716 15 15 15z"/><path d="M512 176V65c0-35.841-29.159-65-65-65H261c-35.841 0-65 29.159-65 65v116h-20c-54.827 0-100.809 38.57-112.255 90H61v-92.58c17.459-6.192 30-22.865 30-42.42 0-24.813-20.187-45-45-45S1 111.187 1 136c0 19.555 12.541 36.228 30 42.42v94.821C13.023 279.142 0 296.074 0 316v60c0 24.813 20.187 45 45 45h18.527c11.069 51.929 57.291 91 112.473 91h160c55.182 0 101.404-39.071 112.473-91H467c24.813 0 45-20.187 45-45v-60c0-24.813-20.187-45-45-45h-18.751a114.853 114.853 0 0 0-11.247-30H447c35.841 0 65-29.159 65-65zM226 65c0-19.299 15.701-35 35-35h186c19.299 0 35 15.701 35 35v111c0 19.299-15.701 35-35 35H271c-2.329 0-4.625.542-6.708 1.583L226 231.729zM46 121c8.271 0 15 6.729 15 15s-6.729 15-15 15-15-6.729-15-15 6.729-15 15-15zM30 376v-60c0-8.271 6.729-15 15-15h16v90H45c-8.271 0-15-6.729-15-15zm452-60v60c0 8.271-6.729 15-15 15h-16v-90h16c8.271 0 15 6.729 15 15zm-61-20v101c0 46.869-38.131 85-85 85H176c-46.869 0-85-38.131-85-85V296c0-46.869 38.131-85 85-85h20v45c0 11.132 11.742 18.4 21.708 13.416L274.541 241h126.241A84.885 84.885 0 0 1 421 296z"/><path d="M272 166h164c8.284 0 15-6.716 15-15s-6.716-15-15-15H272c-8.284 0-15 6.716-15 15s6.716 15 15 15zM211 406c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15s-6.716-15-15-15h-60c-8.284 0-15 6.716-15 15z"/></g></svg>',
    tokens: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="14 14 112 112" aria-hidden="true" focusable="false"><g fill="currentColor"><path d="m49.7 43.72-12 37.44A1.39 1.39 0 0 0 39 83h3.36a1.39 1.39 0 0 0 1.33-1l1.88-6H62l-.23-.37L63.83 82a1.39 1.39 0 0 0 1.33 1h3.36a1.39 1.39 0 0 0 1.33-1.82l-12-37.44a1.4 1.4 0 0 0-1.33-1H51a1.39 1.39 0 0 0-1.3.98M47.57 70l6.19-19.27L60 70Z"/><rect width="6" height="40.24" x="79" y="42.75" rx="1.4"/><path d="M67.26 98h-29.1A8.16 8.16 0 0 1 30 89.84V38.16A8.16 8.16 0 0 1 38.16 30h51.68A8.16 8.16 0 0 1 98 38.16V64a2.07 2.07 0 0 0 2.12 2 11 11 0 0 1 4.91 1.14 2.06 2.06 0 0 0 3-1.87V38.16A18.16 18.16 0 0 0 89.84 20H38.16A18.16 18.16 0 0 0 20 38.16v51.68A18.16 18.16 0 0 0 38.16 108h33.3a2.07 2.07 0 0 0 1.47-3.53 16.1 16.1 0 0 1-3.71-5.06A2.11 2.11 0 0 0 67.26 98"/><path d="m111.73 101.8 9.06-3.57a1 1 0 0 0 0-1.86l-9.06-3.57a12.6 12.6 0 0 1-7.09-7.09l-3.57-9a1 1 0 0 0-.93-.63 1 1 0 0 0-.93.63l-3.57 9a12.58 12.58 0 0 1-7.09 7.09l-9 3.57a1 1 0 0 0 0 1.86l9 3.57a12.58 12.58 0 0 1 7.09 7.09l3.57 9a1 1 0 0 0 .93.64 1 1 0 0 0 .93-.64l3.57-9a12.6 12.6 0 0 1 7.09-7.09"/></g></svg>',
    connections: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="-37.926 -37.926 758.519 758.519" aria-hidden="true" focusable="false"><g fill="none" stroke="currentColor" stroke-width="30" stroke-linecap="round" stroke-linejoin="round"><g transform="matrix(1.33333 0 0 -1.33333 0 682.667)"><path d="M0 0h-16.067" transform="translate(63.2 336.334)"/><path d="M0 0h16.067" transform="translate(448.8 175.667)"/><path d="M0 0v16.067" transform="translate(175.667 448.8)"/><path d="M0 0v-16.067" transform="translate(336.334 63.2)"/></g><path d="m0 0-11.327 11.361" transform="matrix(1.33333 0 0 -1.33333 128.182 128.187)"/><path d="m0 0 11.327-11.361" transform="matrix(1.33333 0 0 -1.33333 554.485 554.48)"/><g transform="matrix(1.33333 0 0 -1.33333 0 682.667)"><path d="M0 0a32.13 32.13 0 0 1 9.399 22.722A32.13 32.13 0 0 1 0 45.444a32.18 32.18 0 0 1-22.734 9.411 32.18 32.18 0 0 1-22.735-9.411A425147 425147 0 0 1-90.938 0l45.469-45.443S-19.842-19.826 0 0" transform="translate(221.939 267.36)"/><path d="M0 0a32.13 32.13 0 0 1 9.399 22.722A32.13 32.13 0 0 1 0 45.444a32.17 32.17 0 0 1-22.734 9.411 32.18 32.18 0 0 1-22.734-9.411C-65.231 25.617-90.856 0-90.856 0l45.388-45.443S-19.842-19.826 0 0" transform="translate(312.795 176.474)"/><path d="m0 0-159.059 159.052s-15.746-15.72-34.062-34.083c-31.41-31.372-31.41-82.237 0-113.608a23993 23993 0 0 0 45.388-45.444c31.411-31.372 82.262-31.372 113.672 0C-15.745-15.719 0 0 0 0" transform="translate(278.734 119.67)"/><path d="m0 0-159.059 159.052s15.745 15.719 34.061 34.082c31.41 31.373 82.261 31.373 113.672 0a24293 24293 0 0 1 45.388-45.443c31.41-31.372 31.41-82.236 0-113.608C15.746 15.719 0 0 0 0" transform="translate(392.325 233.278)"/><path d="m0 0-45.388 45.444-70.613-70.588 45.469-45.443z" transform="translate(131.001 85.587)"/><path d="m0 0-45.469 45.443-70.532-70.588 45.388-45.442z" transform="translate(497 451.557)"/></g></g></svg>',
};
const CHECK_PATH = '<path d="M20 6 9 17l-5-5"/>';
// Lucide "check-check": "Mark all as read" where there is no room for its text (the bell's header).
const CHECK_CHECK_PATHS = '<path d="M18 6 7 17l-5-5"/><path d="m22 10-7.5 7.5L13 16"/>';

const svgIcon = (paths) => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${paths}</svg>`;

export function tr(key, defaultValue, options = {}) {
    const value = i18next.isInitialized ? i18next.t(key, {defaultValue, ...options}) : '';
    return value || String(defaultValue).replace('{{count}}', String(options.count ?? ''));
}

export function pageLanguage() {
    return (document.documentElement.lang || 'en').toLowerCase();
}

export function badgeText(count) {
    const value = Number(count) || 0;
    if (value < 1) {
        return '';
    }
    return value > 99 ? '99+' : String(value);
}

export function isSafeUrl(value) {
    try {
        const url = new URL(String(value), window.location.origin);
        return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (error) {
        return false;
    }
}

const localeDataByLanguage = new Map();

// A browser without the language's locale data (seen for kk) still accepts it but formats in the root locale:
// "-3 d", "2026 M09 28". The root locale is recognisable by its month name "M01" and its "-3 d".
// (Comparing with the "und" locale does not work: browsers resolve it to their own language.)
function hasLocaleData(lang) {
    if (!localeDataByLanguage.has(lang)) {
        let hasData;
        try {
            const month = new Intl.DateTimeFormat(lang, {month: 'long'}).format(new Date(2020, 0, 15));
            const relative = new Intl.RelativeTimeFormat(lang, {numeric: 'always'}).format(-3, 'day');
            hasData = !/^M\d{2}$/.test(month) && !/^[-−]\s?\d/.test(relative);
        } catch (error) {
            hasData = false;
        }
        localeDataByLanguage.set(lang, hasData);
    }
    return localeDataByLanguage.get(lang);
}

// The page's own strings when the browser cannot format the language itself.
function fallbackRelativeTime(date, distance) {
    if (distance >= WEEK_SECONDS) {
        const pad = (value) => String(value).padStart(2, '0');
        return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
    }
    if (distance >= 86400) {
        return tr('common:notifications.timeDaysAgo', '{{count}} d ago', {count: Math.round(distance / 86400)});
    }
    if (distance >= 3600) {
        return tr('common:notifications.timeHoursAgo', '{{count}} h ago', {count: Math.round(distance / 3600)});
    }
    if (distance >= 60) {
        return tr('common:notifications.timeMinutesAgo', '{{count}} min ago', {count: Math.round(distance / 60)});
    }
    return tr('common:notifications.timeNow', 'just now');
}

export function formatRelativeTime(isoString, lang, now = Date.now()) {
    const date = new Date(isoString);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    // A server clock ahead of the browser's clock must not produce "in 2 minutes": future times read as now.
    const seconds = Math.min(0, Math.round((date.getTime() - now) / 1000));
    const distance = Math.abs(seconds);
    if (!hasLocaleData(lang)) {
        return fallbackRelativeTime(date, distance);
    }
    try {
        if (distance >= WEEK_SECONDS) {
            return new Intl.DateTimeFormat(lang, {dateStyle: 'medium'}).format(date);
        }
        const formatter = new Intl.RelativeTimeFormat(lang, {numeric: 'auto'});
        for (const [unit, size] of RELATIVE_UNITS) {
            if (distance >= size) {
                return formatter.format(Math.round(seconds / size), unit);
            }
        }
        return formatter.format(0, 'second');
    } catch (error) {
        return date.toLocaleString();
    }
}

export function markAllIconHtml() {
    return svgIcon(CHECK_CHECK_PATHS);
}

export function categoryIcon(category) {
    return SITE_ICONS[category] || svgIcon(ICON_PATHS[category] || ICON_PATHS.system);
}

export function dispatchCount(count) {
    document.dispatchEvent(new CustomEvent(COUNT_EVENT, {detail: {count}}));
}

export function dispatchRead({id = null, upToId = null}) {
    document.dispatchEvent(new CustomEvent(READ_EVENT, {detail: {id, upToId}}));
}

// The list's error state; the bell and the page both handle clicks on [data-inapp-retry].
export function loadErrorHtml({compact = false} = {}) {
    return emptyStateHtml({
        title: tr('common:notifications.loadError', 'Could not load notifications'),
        actionHtml: `<button type="button" class="outline-button" data-inapp-retry>${escapeHtml(tr('common:retry', 'Retry'))}</button>`,
        compact,
    });
}

// A stray click neither reads nor opens an item: the second click of a double click (after the page's
// "Mark as read" re-renders the item, it lands on the item) or the click that ends a text selection.
export function isStrayClick(event) {
    const selection = window.getSelection();
    return event.detail > 1 || Boolean(selection && !selection.isCollapsed);
}

// Shows a rendered item as read without re-rendering it, so a focused link inside keeps its focus.
export function markItemElementRead(element) {
    element.classList.remove('inapp-item--unread');
    element.querySelectorAll('.inapp-item__dot, .inapp-item__title > .visually-hidden, [data-inapp-mark-read]')
        .forEach((node) => node.remove());
}

// categoryLabel: a chip before the time, for lists that mix categories (the page's "All" card).
export function notificationItemHtml(item, {lang, showMarkRead = false, categoryLabel = ''} = {}) {
    const unread = !item.is_read;
    // The server already drops unsafe links; an unsafe one here renders as a plain title that goes nowhere.
    const url = item.url && isSafeUrl(item.url) ? escapeHtml(item.url) : '';
    const title = escapeHtml(item.title);
    const created = new Date(item.created_at);
    const exact = Number.isNaN(created.getTime()) ? '' : escapeHtml(created.toLocaleString(lang));
    const marker = unread
        ? `<span class="inapp-item__dot" aria-hidden="true"></span><span class="visually-hidden">${escapeHtml(tr('common:notifications.unreadMarker', 'Unread'))}</span>`
        : '';
    const heading = url ? `<a class="inapp-item__link" href="${url}">${title}</a>` : `<span>${title}</span>`;
    // body_html is sanitized on the server (notifications/inapp_render.py).
    const body = item.body_html ? `<div class="inapp-item__body">${item.body_html}</div>` : '';
    const organization = item.organization
        ? `<span class="inapp-item__organization">${escapeHtml(item.organization.name)}</span>`
        : '';
    const category = categoryLabel ? `<span class="inapp-item__category">${escapeHtml(categoryLabel)}</span>` : '';
    const markReadLabel = escapeHtml(tr('common:notifications.markRead', 'Mark as read'));
    const markRead = showMarkRead && unread
        ? `<button type="button" class="icon-btn inapp-item__mark-read" data-inapp-mark-read aria-label="${markReadLabel}" title="${markReadLabel}">${svgIcon(CHECK_PATH)}</button>`
        : '';
    return `
        <article class="inapp-item${unread ? ' inapp-item--unread' : ''}" data-inapp-item="${Number(item.id)}"${url ? ` data-inapp-url="${url}"` : ''}>
            <span class="inapp-item__icon">${categoryIcon(item.category)}</span>
            <div class="inapp-item__content">
                <div class="inapp-item__title">${marker}${heading}</div>
                ${body}
                <div class="inapp-item__meta">
                    ${category}
                    <time datetime="${escapeHtml(item.created_at)}" title="${exact}">${escapeHtml(formatRelativeTime(item.created_at, lang))}</time>
                    ${organization}
                </div>
            </div>
            ${markRead}
        </article>`;
}
